import { BinanceChainId } from './types';

export const supportedChainId: string[] = [BinanceChainId.Mainnet];

export const ACTIONS_PREFIX = 'binance/';
export const VALIDATOR_ADDRESS = 'bva1xnudjls7x4p48qrk0j247htt7rl2k2dzp3mr3j';
export const VALIDATOR_NAME = 'Ankr_BSC_validator_1';
